import styled from 'styled-components';
import BoxContainer from 'containers/BoxContainer';
import {transparentize} from 'polished';

export const Wrapper = styled(BoxContainer)`
  column-gap: 7px;
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;
  list-style: none;
  padding: 8px;
  margin: 0;
`;

export const Item = styled.li`
  column-gap: 7px;
  align-items: center;
  grid-auto-flow: column;
  display: inline-grid;
  font-size: 14px;
  color: ${({theme}) => transparentize(.4, theme.variables.color)};
  
  &:not(:last-child):after {
    content: "•";
  }
`;
